// extracted by mini-css-extract-plugin
module.exports = {"Controller":"Controller_Controller__33CVG","Label":"Controller_Label__3MORM","Less":"Controller_Less__2hQ4O","More":"Controller_More__1YtIT"};